// extracted by mini-css-extract-plugin
module.exports = {"styledEditor":"ReactPlayground-StyledEditor-module--styled-editor--TvjTT prism-module--prism--2-Zwl"};